<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-12">
        <h2 *ngIf="esNuevo">Nueva Fórmula</h2>
        <h2 *ngIf="!esNuevo">Fórmula - {{formulaActual?.codigo}}</h2>
        <input *ngIf="!esNuevo" class="form-control" type="text" [(ngModel)]="inputDescripcion">
    </div>
</div>
<div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
        <div class="col-lg-12">
            <div class="ibox ">
                <div class="ibox-content">
                    
                    <div class="blockly">
                        <div class="btn-group row">
                            <button *ngIf="permisoEdicion" class="btn btn-primary btn-sg" (click)="toCode(template)" >Guardar</button>
                            <button *ngIf="permisoEdicion" class="btn btn-primary btn-sg" (click)="toCopy(template)" [disabled]="esNuevo">Guardar Como</button>
                            <button *ngIf="permisoEdicion" class="btn btn-secondary btn-sg" (click)="cancelar()">Cancelar</button>
                        </div>
                        <hr>
                        
                        <div  id="blocklyDiv" style="width: 100%; height: 100%" class="row">
                            <ngx-blockly #Blockly [config]="config" [customBlocks]="customBlocks" [generatorConfig]="generatorConfig"></ngx-blockly>
                            
                            <ng-template #template>
                                <div class="modal-header">
                                    <h4 class="modal-title">Guardar fórmula</h4>
                                    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <div class="form-group  row">
                                        <label class="col-sm-2 col-form-label font-bold">Código</label>
                                        <div class="col-sm-10"><input type="text" #nombre class="form-control"></div>
                                    </div>
                                    <div class="form-group  row">
                                        <label class="col-sm-2 col-form-label font-bold">Descripción</label>
                                        <div class="col-sm-10"><input type="text" #descripcion class="form-control"></div>
                                    </div>
                                    <div *ngIf="formulaInvalida" class="form-group  row">
                                        <mat-error class="formulaInvalida">{{MensajeError}}</mat-error>
                                    </div>
                                </div>                                
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-white" (click)="modalRef.hide()">Cancelar</button>
                                    <button class="btn btn-primary btn-lg" (click)="save(0,nombre.value,descripcion.value)">Guardar</button>
                                </div>
                            
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>    
</div>
    
     